import { render, staticRenderFns } from "./RequestFinishedHandSanitizer.vue?vue&type=template&id=d106db7e&scoped=true&"
import script from "./RequestFinishedHandSanitizer.vue?vue&type=script&lang=js&"
export * from "./RequestFinishedHandSanitizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d106db7e",
  null
  
)

export default component.exports